import * as React from 'react';
import { StyleguideConfig, StyleguidePages } from '../types';
import { StyleguidePage } from './renderers';

export const StyleguideContent = (props: { currentPage: StyleguidePages; config: StyleguideConfig }) => {
  const { currentPage, config } = props
  const { components, compositions, objects, tokens } = config.chapters
  return (
    <>
      <div className="styleguide__content">
        {currentPage.includes('tokens') &&
          tokens.length > 0 &&
          tokens.map(
            (tokenChapter) =>
              currentPage == tokenChapter.slug && (
                <StyleguidePage key={tokenChapter.slug} chapterType={tokenChapter.slug} config={tokenChapter} />
              )
          )}

        {currentPage.includes('objects') &&
          objects.length > 0 &&
          objects.map(
            (objectsChapter) =>
              currentPage == objectsChapter.slug && (
                <StyleguidePage key={objectsChapter.slug} chapterType={objectsChapter.slug} config={objectsChapter} />
              )
          )}

        {currentPage.includes('components') &&
          components.length > 0 &&
          components.map(
            (componentChapter) =>
              currentPage == componentChapter.slug && (
                <StyleguidePage
                  key={componentChapter.slug}
                  chapterType={componentChapter.slug}
                  config={componentChapter}
                />
              )
          )}

        {currentPage.includes('compositions') &&
          compositions.length > 0 &&
          compositions.map(
            (compositionChapter) =>
              currentPage == compositionChapter.slug && (
                <StyleguidePage
                  key={compositionChapter.slug}
                  chapterType={compositionChapter.slug}
                  config={compositionChapter}
                />
              )
          )}
      </div>
    </>
  )
}
